module.exports = __webpack_public_path__ + "img/blue_squares.67e75534.png";